import { createLazyComponent, LazyAction, LazyModule } from 'owa-bundling';
export { clickCalendarEvent, doubleClickCalendarEvent } from './actions/publicActions';
export * from './components/ConflictsView.types';

const lazyModule = new LazyModule(() =>
    import(/*webpackChunckName: "ConflictsView" */ './lazyIndex')
);

export const lazyInitializeConflictsView = new LazyAction(
    lazyModule,
    m => m.initializeConflictsView
);

export const ConflictsView = createLazyComponent(lazyModule, m => m.ConflictsView);
